import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CheckCircle, Scroll } from "@phosphor-icons/react";

export default function SignupStep1Tier({
  pricing, tier, setTier, tcAccepted, setTcAccepted, onBack, onContinue,
}) {
  const handleContinue = () => {
    if (!tcAccepted) { toast.error("Please accept the terms to continue."); return; }
    onContinue();
  };

  return (
    <>
      <div className="grid sm:grid-cols-2 gap-5">
        {pricing.tiers.map((t) => {
          const selected = tier === t.id;
          return (
            <button
              type="button"
              key={t.id}
              data-testid={`tier-${t.id}`}
              onClick={() => setTier(t.id)}
              className={`text-left rounded-2xl border-2 p-6 transition-all ${selected ? "border-cvc-red bg-white shadow-md" : "border-cvc-border bg-white hover:border-cvc-navy"}`}
            >
              <div className="flex items-center justify-between">
                <p className="text-xs tracking-[0.2em] uppercase font-body font-semibold text-cvc-red">{t.meetings_per_month} meetings / mo</p>
                {selected && <CheckCircle size={22} weight="fill" className="text-cvc-red" />}
              </div>
              <h3 className="font-heading text-2xl text-cvc-navy mt-2">{t.name}</h3>
              <p className="font-body text-sm text-cvc-ink-soft mt-2">{t.tagline}</p>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-heading text-4xl text-cvc-navy">${t.monthly_total.toLocaleString()}</span>
                <span className="font-body text-cvc-ink-soft text-sm">/mo</span>
              </div>
              <p className="font-body text-xs text-cvc-ink-soft mt-1">
                ${t.price_per_meeting.toLocaleString()} / meeting · First + last-month retainer ${t.first_last_retainer.toLocaleString()}
              </p>
              <p className="font-body text-xs text-cvc-ink-soft mt-3 italic">{t.best_for}</p>
            </button>
          );
        })}
      </div>

      <div className="rounded-2xl border border-cvc-border bg-white">
        <div className="flex items-center gap-2 px-5 py-3 border-b border-cvc-border">
          <Scroll size={20} weight="duotone" className="text-cvc-navy" />
          <h4 className="font-heading text-xl text-cvc-navy">Engagement Letter & Terms</h4>
        </div>
        <ScrollArea className="h-56 p-5">
          <pre className="whitespace-pre-wrap font-body text-xs text-cvc-ink-soft leading-relaxed">
            {pricing.terms}
          </pre>
        </ScrollArea>
        <div className="px-5 py-4 border-t border-cvc-border flex items-start gap-3">
          <Checkbox
            id="tc-accept"
            data-testid="signup-tc-checkbox"
            checked={tcAccepted}
            onCheckedChange={(v) => setTcAccepted(!!v)}
          />
          <Label htmlFor="tc-accept" className="font-body text-sm text-cvc-ink leading-relaxed cursor-pointer">
            I have read and agree to the Engagement Letter and Terms & Conditions. I understand CVC will review my case and may either accept me as a prepared-client or require preparation steps before acceptance.
          </Label>
        </div>
      </div>

      <div className="flex items-center justify-between gap-4 flex-wrap">
        {onBack ? (
          <Button variant="ghost" data-testid="signup-step1-back" onClick={onBack} className="text-cvc-ink-soft">← Back</Button>
        ) : <span />}
        <div className="flex items-center gap-4 flex-wrap ml-auto">
          <p className="font-body text-xs text-cvc-ink-soft italic">Jonathan may require meeting before accepting your case. Payment is not processed until you're accepted as a client.</p>
          <Button
            data-testid="signup-step1-next"
            onClick={handleContinue}
            className="bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full px-8 py-5 h-auto"
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
}
